import { isValidElement } from 'react';
import Immutable from 'immutable';
import { Children } from 'react';
export default function groupCellsByTable(cells) {
  if (!Immutable.Iterable.isIterable(cells) || isValidElement(cells.first())) {
    return Children.toArray(cells).reduce(function (tables, cell) {
      var tableId = cell.props.node.getIn(['data', 'tableId']);

      if (tables[tableId]) {
        tables[tableId].push(cell);
      } else {
        tables[tableId] = [cell];
      }

      return tables;
    }, {});
  }

  return cells.reduce(function (tables, cell) {
    return tables.update(cell.getIn(['data', 'tableId']), new Immutable.List(), function (cells) {
      return cells.push(cell);
    });
  }, new Immutable.Map());
}